import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { load, save, confirm } from "actions/hdfActions";
import { getInitialValues } from "reducers/hdfReducer";
import PrudentialHDF from "./form";
import PrudentialHDF202101 from "./Form202101";
import { PRUDENTIAL_HDF_202101_ID } from "../constants";
import { getHDFId } from "../utils";
class PrudentialHdfPage extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    planYearId: PropTypes.string,
    enrolmentKey: PropTypes.string,
    load: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    confirm: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const { location } = props;
    const hdfId = getHDFId(location);

    this.state = { hdfId };
  }

  componentDidMount() {
    const { hdfId } = this.state;
    const { load, planYearId, enrolmentKey } = this.props;
    load(hdfId, planYearId, enrolmentKey);
  }

  render() {
    const Form =
      this.state.hdfId === PRUDENTIAL_HDF_202101_ID ? PrudentialHDF202101 : PrudentialHDF;
    return (
      <div>
        <Helmet>
          <link rel="stylesheet" type="text/css" href="/assets/css/hdf/prudential.css" />
        </Helmet>

        <Form {...this.props} />
      </div>
    );
  }
}

/**
 * React-redux
 * @param  {object} state
 * @return {object}
 */
const mapStateToProps = (
  { hdf: { employeeParticulars }, form },
  {
    match: {
      params: { planYearId, enrolmentKey },
    },
  }
) => ({
  initialValues: getInitialValues(employeeParticulars),
  prudentialForm: form.prudentialHdf,
  employeeParticulars,
  planYearId,
  enrolmentKey,
});

/**
 * React-redux
 * @type {object}
 */
const mapDispatchToProps = { load, save, confirm };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrudentialHdfPage);



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Prudential/index.js